import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.REACT_APP_VERSION === "NZT") {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}
